<template>
  <div>
    <l-tables
      :tableConfig="tableConfig"
      ref="table"
      :columnId="columnId"
      :searchParams="searchData"
      :noCreatText="noCreatText"
      :ImgSrc="nullImg"
      @tableChange="handleTableHeaderChange"
    >
      <template slot="searchConditions">
        <a-input
          v-model="keyword"
          @change="search"
          maxlength="30"
          :placeholder="$t('admin.content.recruit.list.searchPlaceholder')"
        >
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img
            class="clear"
            v-if="keyword"
            slot="suffix"
            @click=";(keyword = undefined), search()"
            :src="require('@/assets/icons/icon_gb.png')"
          />
        </a-input>
      </template>
      <template #zpTitle="{record}">
        <template v-if="record">
          <a-tooltip placement="bottom">
            <template slot="title">
              <span>{{ record.title }}</span>
            </template>
            <span class="overF">{{ record.title }}</span>
          </a-tooltip>
        </template>
      </template>
      <template #applicationStartDate="{record}">
        <template v-if="record">
          <span>{{ record.applicationStartDate }} {{ $t('common.to') }} {{ record.applicationEndDate }}</span>
        </template>
      </template>
      <template #status="{record}">
        <template v-if="record">
          <span>{{
            record.status == 1
              ? $t('admin.content.recruit.list.filters.status.open')
              : $t('admin.content.recruit.list.filters.status.closed')
          }}</span>
        </template>
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="create"
          >{{ $t('admin.content.recruit.list.create') }}{{ columnTitle }}</a-button
        >
      </template>
      <template slot="create">
        <a-button type="primary" @click="create"
          >{{ $t('admin.content.recruit.list.create') }}{{ columnTitle }}</a-button
        >
      </template>
    </l-tables>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'

export default {
  components: {
    LTables
  },
  data() {
    return {
      columnId: 0,
      noCreatText: '',
      nullImg: require('@/assets/img/trainingRoomlistNull.png'),
      keyword: undefined,
      searchData: {
        keyword: ''
      },
      tableConfig: {
        tableName: '',
        tableColumns: [
          {
            title: this.$t('admin.content.recruit.list.columns.index'),
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 80
          },
          {
            title: this.$t('admin.content.recruit.list.columns.title'),
            dataIndex: 'title',
            key: 'title',
            align: 'center',
            ellipsis: true,
            width: 300,
            scopedSlots: { customRender: 'zpTitle' }
          },
          {
            title: this.$t('admin.content.recruit.list.columns.deliveryNumber'),
            dataIndex: 'deliveryNumber',
            key: 'deliveryNumber',
            align: 'center',
            ellipsis: true
          },
          {
            title: this.$t('admin.content.recruit.list.columns.status'),
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            scopedSlots: { customRender: 'status' },
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: this.$t('admin.content.recruit.list.filters.status.open'), value: '1' },
              { text: this.$t('admin.content.recruit.list.filters.status.closed'), value: '2' }
            ]
          },
          {
            title: this.$t('admin.content.recruit.list.columns.applicationTime'),
            dataIndex: 'applicationStartDate',
            key: 'applicationStartDate',
            align: 'center',
            scopedSlots: { customRender: 'applicationStartDate' }
          },
          {
            title: this.$t('admin.content.recruit.list.columns.createdAt'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center'
          },
          {
            title: this.$t('admin.content.recruit.list.columns.operations'),
            dataIndex: 'operate',
            key: 'operate',
            align: 'center',
            scopedSlots: { customRender: 'operate' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('admin.content.recruit.list.deleteConfirm.title'),
          content: this.$t('admin.content.recruit.list.deleteConfirm.content')
        },
        tablePort: {
          list: '/admin/portal/job/list',
          del: '/admin/portal/job/delete'
        },
        tableEditRouteNName: 'recruitListAdd'
      },
      columnTitle: this.$route.query.columnTitle
    }
  },
  watch: {
    $route() {
      this.columnId = this.$route.query.columnId
      this.columnTitle = this.$route.query.columnTitle
      this.$ref.table.getList()
    }
  },
  created() {
    this.columnId = this.$route.query.columnId
    const { columnTitle, pColumnTitle } = this.$route.query
    this.tableConfig.tableName = pColumnTitle ? `${pColumnTitle}-${columnTitle}` : columnTitle
    this.noCreatText = `${this.$t('admin.content.recruit.nodata')}${this.columnTitle}`
  },
  methods: {
    search() {
      this.searchData.keyword = this.keyword
    },
    // 新建
    create() {
      this.$router.push({
        name: 'recruitListAdd',
        query: {
          columnId: this.columnId,
          columnTitle: this.columnTitle
        }
      })
    },
    handleTableHeaderChange([filters, getList, sorter]) {
      let result = {}
      result.statuses = filters.status
      getList({ condition: result })
    }
  }
}
</script>

<style lang="less" scoped>
.overF {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto;
}
</style>
